import { Component } from '@angular/core';

@Component({
  selector: 'app-sm-in-navigation',
  templateUrl: './sm-in-navigation.component.html',
  styleUrls: ['./sm-in-navigation.component.css']
})
export class SmInNavigationComponent {

}
